import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { SupplierBasket } from '@lib/basket/suppliers-basket/basket-supplier/basket-supplier-item/ui';

@Component({
    selector: 'basket-header-content',
    templateUrl: './basket-header-content.component.html',
    styleUrls: ['./basket-header-content.component.scss'],
    standalone: false
})
export class BasketHeaderContentComponent implements OnChanges {
    @Input() isExpanded!: boolean;

    @Input() supplierBaskets!: SupplierBasket[];

    @Output() basketOpened = new EventEmitter<any>();

    itemsExist = false;

    itemCount = 0;

    open(): void {
        this.basketOpened.emit();
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes['supplierBaskets']) {
            this.getNumberOfItems();
            this.isThereAnyItems();
        }
    }

    isThereAnyItems(): void {
        if (!this.supplierBaskets || this.supplierBaskets.length < 1) {
            this.itemsExist = false;
        } else {
            this.supplierBaskets.map((supplier) => {
                if (supplier.basketItems.length > 0) {
                    this.itemsExist = true;
                }
            });
        }
    }

    getNumberOfItems(): void {
        if (!this.supplierBaskets || this.supplierBaskets.length < 1) {
            this.itemCount = 0;
        } else {
            this.itemCount = this.supplierBaskets.reduce(
                (sum: number, basket: SupplierBasket) => sum + basket.basketItems.length,
                0,
            );
        }

    }
}
